module.exports = __webpack_public_path__ + "static/media/Vieos Image.b92e68dd.png";